import {specialScrollbar} from "./special-scrollbar.jsx";

const sweetAlertOverrides = {
  sweetAlertWrapper: {
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: "1040",
    backgroundColor: "rgba(238, 238, 238, 0.6);",
    position: "fixed",
    overflowY: "auto",
  },
  sweetAlertWrapperInner: {
    width: "100%",
    height: "100%",
    display: "table",
    alignItems: "center",
    justifyContent: "center",
    "&>div": {
      display: "table-cell",
      verticalAlign: "middle",
      "&>div:nth-of-type(1)": {
        display: "none"
      },
      ...specialScrollbar,
      "&>div>h2": {
        margin: 0
      },
      "&>div>div": {
        textAlign: "initial",
        position: "relative"
      }
    }
  },
  sweetAlertClose: {
    top: 8,
    right: -13,
    color: "#9d9d9d",
    width: "48px",
    height: "45px",
    lineHeight: "60px",
    position: "absolute",
    cursor: "pointer",
    fontSize: "15px",
    textAlign: "center",
    zIndex: 1
  }
};

export {
  sweetAlertOverrides
}
